// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2M4o0","colMaxWidth":"Table_colMaxWidth__6fvDK"};